module.exports = require("./es-EA.js");